export const DISPLAY_CHARTS_MAPPER = {
  primaryMarket: 'primaryMarket',
  primaryMarketEcoMap: 'primaryMarketEcoMap',
  primaryMarketGeneral: 'primaryMarketGeneral',
  secondaryMarket: 'secondaryMarket',
  transactions: 'transactions',
};

export const FLOW_POINTS = [
  {
    id: 'school',
    label: 'Instituições de ensino',
    checked: false,
    color: '#2BD798',
    markers: [],
  },
  {
    id: 'bank',
    label: 'Instituições financeiras',
    checked: false,
    color: '#1DA9F7',
    markers: [],
  },
  {
    id: 'supermarket',
    label: 'Mercados',
    checked: false,
    color: '#A01E1E',
    markers: [],
  },
  {
    id: 'shopping_mall',
    label: 'Shopping',
    checked: false,
    color: '#FEED50',
    markers: [],
  },
  {
    id: 'park',
    label: 'Praças',
    checked: false,
    color: '#13821F',
    markers: [],
  },
  {
    id: 'hospital',
    label: 'Hospitais',
    checked: false,
    color: '#2F149D',
    markers: [],
  },
  {
    id: 'subway_station',
    label: 'Estações de metrô',
    checked: false,
    color: '#FF8C00',
    markers: [],
  },
];

export const LocalStorageMapper = {
  ConstructionPatterns: 'ConstructionPatterns',
  Statuses: 'Statuses',
  Companies: 'Companies',
  LaunchingYearsTransactions: 'LaunchingYearsTransactions',
  LaunchingYearsPrimary: 'LaunchingYearsPrimary',
  LaunchingYearsMarketCycle: 'LaunchingYearsMarketCycle',
  BuildingsNames: 'BuildingsNames',
};
